import { ISearchSelectChange } from '../interfaces/Index';
export const channelEnum = {
	CUSTOMER_APP: 'Customer App',
	AGENT_APP: 'Agent App',
	TELESALES_COMMANDO: 'Telesales',
	CORPORATE_COMMANDO: 'Corporate',
	ADMIN_COMMANDO: 'Internal',
	KHAATA_APP: 'Khaata App',
};

export const isActivated = {
	Activate: 'Activate account',
	Deactivate: 'Deactivate account',
};

export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const SOMETHING_UNEXPECTED_HAPPENED = 'Something unexpected happened';

export const COMMANDO_CLIENT_ID = '28jBOemnHcrEuYbARIQn8K';
export const CUSTOMER_APP_ID = '6oBLcwals64uAw6PTkHPnd';

export const CLIENT_ROLE_ERROR_TEXT = {
	selectClient: 'Please select clients',
	roleMustHaveClient: 'Selected roles must have associated clients',
	selectRole: 'Client must have a role selected',
};

export const CLIENT_FILTER_ERROR_TEXT = {
	filterMustHaveClient: 'Selected filters must have associated clients',
};

export const TOUR_REASSIGNMENT_CODES = [4001, 3001];

export const MOCK_ABILITY = [
	{
		subject: 'store',
		action: 'create',
	},
	{
		subject: 'store',
		action: 'update',
	},
	{
		subject: 'store',
		action: 'read',
	},
	{
		subject: 'product',
		action: 'create',
	},
	{
		subject: 'product',
		action: 'update',
	},
	{
		subject: 'product',
		action: 'read',
	},
	{
		subject: 'category',
		action: 'create',
	},
	{
		subject: 'category',
		action: 'update',
	},
	{
		subject: 'category',
		action: 'read',
	},
	{
		subject: 'order',
		action: 'create',
	},
	{
		subject: 'order',
		action: 'update',
	},
	{
		subject: 'order',
		action: 'read',
	},
	{
		subject: 'image',
		action: 'create',
	},
	{
		subject: 'image',
		action: 'update',
	},
	{
		subject: 'image',
		action: 'read',
	},
	{
		subject: 'user',
		action: 'create',
	},
	{
		subject: 'user',
		action: 'update',
	},
	{
		subject: 'user',
		action: 'read',
	},
	{
		subject: 'access',
		action: 'create',
	},
	{
		subject: 'access',
		action: 'update',
	},
	{
		subject: 'access',
		action: 'read',
	},
	{
		subject: 'promo',
		action: 'create',
	},
	{
		subject: 'promo',
		action: 'update',
	},
	{
		subject: 'promo',
		action: 'read',
	},
	{
		subject: 'promo',
		action: 'avail',
	},
	{
		subject: 'banner',
		action: 'read',
	},
	{
		subject: 'banner',
		action: 'update',
	},
	{
		subject: 'plan',
		action: 'update',
	},
	{
		subject: 'plan',
		action: 'create',
	},
	{
		subject: 'agent',
		action: '*',
	},
	{
		subject: 'rider',
		action: 'create',
	},
	{
		subject: 'shift',
		action: 'create',
	},
	{
		subject: 'shift',
		action: 'read',
	},
	{
		subject: 'tour',
		action: 'update',
	},
	{
		subject: 'tour',
		action: 'read',
	},
	{
		subject: 'tour',
		action: 'create',
	},
	{
		subject: 'zone',
		action: 'create',
	},
	{
		subject: 'zone',
		action: 'update',
	},
	{
		subject: 'zone',
		action: 'read',
	},
	{
		subject: 'deliverydate',
		action: 'read',
	},
	{
		subject: 'deliverydate',
		action: 'create',
	},
	{
		subject: 'deliverydate',
		action: 'update',
	},
	{
		subject: 'wallet',
		action: 'create',
	},
	{
		subject: 'nationalid',
		action: 'read',
	},
	{
		subject: 'nationalid',
		action: 'update',
	},
	{
		subject: 'campaign',
		action: 'create',
	},
	{
		subject: 'post',
		action: 'create',
	},
	{
		subject: 'campaign',
		action: 'update',
	},
	{
		subject: 'campaign',
		action: 'read',
	},
	{
		subject: 'staff',
		action: 'read',
	},
	{
		subject: 'staff',
		action: 'create',
	},
	{
		subject: 'rider',
		action: 'read',
	},
	{
		subject: 'warehouse',
		action: 'read',
	},
	{
		subject: 'config',
		action: 'read',
	},
	{
		subject: 'post',
		action: 'read',
	},
	{
		subject: 'game',
		action: 'update',
	},
	{
		subject: 'store',
		action: 'update',
	},
	{
		subject: 'gift',
		action: 'update',
	},
	{
		subject: 'gift',
		action: 'create',
	},
	{
		subject: 'post',
		action: 'update',
	},
	{
		subject: 'criteria',
		action: 'create',
	},
	{
		subject: 'game',
		action: '*',
	},
	{
		subject: 'game',
		action: 'update',
	},
];
export const BAZAAR_HEADER_KEY = 'X-Bazaar-Client-Key';
export const BAZAAR_SECRET_KEY = '0bcb15a669dc25bc985eb7b7bc159441c0cdbb7b457b8597fc3e8e5ffa3edd70';

export class user {
	constructor(attrs: any) {
		Object.assign(this, attrs);
	}
}

export class access {
	constructor(attrs: any) {
		Object.assign(this, attrs);
	}
}

export const PROMO_SLAB_LEVEL = 2;
export const BASKET_PROMO_SLAB_LEVEL = 1;
export const PROMO_TYPE = {
	VOLUMETRIC: 'VOLUMETRIC',
	BASKET: 'BASKET',
	DYNAMIC: 'DYNAMIC',
	ULP: 'USER_LEVEL',
};
export const PROMO_VALUE_TYPE = {
	INTEGER: 'INTEGER',
	FLOAT: 'FLOAT',
};
export const OPERATORS = {
	EQUALS: 'EQUALS',
	NOT_EQUALS: 'NOT_EQUALS',
	LESS_THAN: 'LESS_THAN',
	GREATER_THAN: 'GREATER_THAN',
	LESS_THAN_EQUALS_TO: 'LESS_THAN_EQUALS_TO',
	GREATER_THAN_EQUALS_TO: 'GREATER_THAN_EQUALS_TO',
};
export const PROMO_FIELDS = {
	DISCOUNT: 'discount',
	QUANTITY: 'quantity',
	AMOUNT: 'amount',
};

export const PROMO_VALIDATION_MESSAGES = {
	STOCK_LESS_THEN_SLAB_UNITS: 'Minimum units is greater then stock',
	SKU_CATEGORY_INACTIVE: 'Category of the concerned SKU is not active',
};

export const ODOO_TAX_TYPE = {
	PURCHASE: 'PURCHASE',
	SALE: 'SALE',
};

export const CHECK_NUMBER_REGEX = /^[0-9]+$/;

export const LOCAL_STORAGE_KEYS = {
	auth: 'auth',
	mfaFactors: 'mfa-factors',
};
export const acceptableFormats: any = {
	image: `.png, .gif, .webp`,
	csv: `.ods,
          .csv,
          application/vnd.openxmlformats-officedocument.spreadsheetm.sheet,
          application/vnd.ms-excel`,
};

export const ERROR_CODES = {
	UNABLE_TO_AUTHENTICATE_MFA_INPUT: 1005,
	MINIMUM_ORDER_VALUE_STATUS: 2001,
};

export enum EVENT_TYPE {
	'ENDED' = 'ENDED',
	'TOURS_ADDED' = 'TOURS_ADDED',
}

export enum UPLOAD_CSV_TYPE {
	'TOUR' = 'TOUR',
}

export const PAGE_LENGTH = 50;

export enum RIDER {
	'UPDATE_RIDER' = 'Update Rider',
	'CREATE_ACCOUNT' = 'Create Account',
	'ADD_RIDER' = 'Add Rider',
}

export enum STATUS {
	'ACTIVE' = 'ACTIVE',
	'INACTIVE' = 'INACTIVE',
}

export const ACTIVATED_TAG = 'activated-tag';

export const DEACTIVATED_TAG = 'deactivated-tag';

export const TOPUP_CITIES = [
	{ value: 'karachi', label: 'Karachi' },
	{ value: 'lahore', label: 'Lahore' },
];

export const CNIC_LISTNG_FILTER = [
	{ id: 'profile', name: 'profile', value: 'profile', label: 'Profile' },
	// { id: "credit", name: "credit", value: "credit", label: "Credit" },
];

export enum CUSTOMER_CHANNEL {
	'GENERAL_TRADE' = 'GENERAL_TRADE',
	'CORPORATE' = 'CORPORATE',
	'ELECTRONICS' = 'ELECTRONICS',
	'PHARMA' = 'PHARMA',
	'SELF_SERVICE_STORE' = 'SELF_SERVICE_STORE',
	'STREET' = 'STREET',
	'OFFICES_INSTITUTIONS' = 'OFFICES_INSTITUTIONS',
}
export enum CREDIT_USER_STATUS {
	'ENABLED' = 'ENABLED',
	'NOT_STARTED' = 'ENABLED',
	'PENDING_VERIFICATION' = 'PENDING_VERIFICATION',
	'IDENTITY_VERIFIED' = 'IDENTITY_VERIFIED',
	'VERIFICATION_FAILED' = 'VERIFICATION_FAILED',
	'ACTIVE' = 'ACTIVE',
	'INACTIVE' = 'INACTIVE',
	'SUSPENDED' = 'SUSPENDED',
	'EXPIRED' = 'EXPIRED',
	'DEFAULTER' = 'DEFAULTER',
	'DISABLED' = 'DISABLED',
}

export enum CNIC_VERIFICATION_TYPE {
	'nationalid' = 'nationalid',
	'userimage' = 'userimage',
}

export enum CNIC_VERIFITCATION_USER_TYPE {
	'USER' = 'USER',
	'OWNER' = 'OWNER',
	'MANAGER' = 'MANAGER',
}

export enum OWNER_VERIFICATION_STATUS {
	'PENDING_VERIFICATION' = 'PENDING_VERIFICATION',
	'IDENTITY_VERIFIED' = 'IDENTITY_VERIFIED',
	'ACTIVE' = 'ACTIVE',
}

export const CNIC_DISQUALIFICATION_REASONS_GENERAL_TRADE: ISearchSelectChange[] = [
	{
		value: 'NATIONALID_NUMBER_MISMATCH',
		label: 'CNIC number mismatch',
	},
	{
		value: 'NATIONALID_SELFIE_MISMATCH',
		label: 'CNIC & Selfie mismatch',
	},
	{
		value: 'NATIONALID_NAME_MISMATCH',
		label: 'CNIC name mismatched',
	},
	{
		value: 'NATIONALID_SELFIE_NOT_VISIBLE',
		label: 'CNIC & Selfie not visible',
	},
	{
		value: 'NATIONALID_EXPIRED',
		label: 'Expired CNIC',
	},
];

export const CNIC_DISQUALIFICATION_REASONS_HORECA: ISearchSelectChange[] = [
	{
		value: 'NATIONALID_NUMBER_MISMATCH',
		label: 'Manger CNIC number mismatch',
	},
	{
		value: 'NATIONALID_SELFIE_MISMATCH',
		label: 'Manager CNIC & Selfie mismatch',
	},
	{
		value: 'NATIONALID_NAME_MISMATCH',
		label: 'Manger CNIC name mismatched',
	},
	{
		value: 'NATIONALID_SELFIE_NOT_VISIBLE',
		label: 'Manger CNIC & Selfie not visible',
	},
	{
		value: 'NATIONALID_EXPIRED',
		label: 'Manager Expired CNIC',
	},
	{
		value: 'OWNER_NATIONALID_NUMBER_MISMATCH',
		label: 'Owner CNIC Number Mismatched',
	},
	{
		value: 'OWNER_NATIONALID_SELFIE_MISMATCH',
		label: 'Owner CNIC & Selfie mismatch',
	},
	{
		value: 'OWNER_NATIONALID_NAME_MISMATCH',
		label: 'Owner name Mismatched',
	},
	{
		value: 'OWNER_NATIONALID_SELFIE_NOT_VISIBLE',
		label: 'Owner CNIC & Selfie not visible',
	},
	{
		value: 'OWNER_NATIONALID_EXPIRED',
		label: 'Owner Expired CNIC',
	},
	{
		value: 'OWNER_MANAGER_NATIONALID_FAILED',
		label: 'Manger or Owner Detail mismatched',
	},
];

export enum TOPUP_API_TYPE {
	'LOAD' = 'LOAD',
	'CREATE' = 'CREATE',
}

export enum DATE_FORMAT {
	'ddMMyyyy' = 'dd/MM/yyyy',
	DATE_TIME = 'dd/MM/yyyy hh:mm:ss',
	'dd_MMM_yyyy' = 'dd MMM yyyy',
	DAY_MONTH_TIME12 = 'do MMM, h:mm aaa',
}

export enum CAMPAIGN_TYPE {
	'ORDER_VALUE' = 'ORDER_VALUE',
	'BRAND_VALUE' = 'BRAND_VALUE',
}

export const CAMPAIGN_TYPE_DROPDOWN = [
	{ value: 'BRAND_VALUE', label: 'Brand' },
	{ value: 'ORDER_VALUE', label: 'Value based' },
];

export enum CNIC_STATUS {
	'UNVERIFIED' = 'UNVERIFIED',
	'VERIFIED' = 'VERIFIED',
	'PENDING' = 'PENDING',
	'OPEN_CREDIT' = 'OPEN_CREDIT',
}

export enum CNIC_MODAL_TYPE {
	'Verify' = 'Verify',
	'Disqualify' = 'Disqualify',
}

export const ZONE_TYPE_STATE = [
	{ value: 'TOWN', label: 'TOWN' },
	{ value: 'UC', label: 'UC' },
];

export const NEWSFEED_CONTENT_TYPE = [
	{ id: 'VIDEO', value: 'VIDEO', label: 'VIDEO' },
	{ id: 'IMAGE', value: 'IMAGE', label: 'IMAGE' },
];

export const TOWN_TYPE = 'TOWN';
export const UC_TYPE = 'UC';

export enum PAIYA_GAME_STATUS {
	'ACTIVE' = 'ACTIVE',
	'INACTIVE' = 'INACTIVE',
}

export const PLAN_CREATION_OPTIONS = [
	{ label: 'Credit Collection', value: 'CREDIT', id: 'CREDIT' },
	{ label: 'Coin Collection', value: 'TOPUP', id: 'TOPUP' },
	{ label: 'Order & Pickup', value: 'Order & Pickup', id: 'RETURN_PICKUP' },
];
export const CUSTOMER_CHANNEL_OPTIONS = [
	{ label: 'Genral Trade', value: 'GENERAL_TRADE', id: 'GENERAL_TRADE' },
	{ label: 'Corporate', value: 'CORPORATE', id: 'CORPORATE' },
	{ label: 'Electronics', value: 'ELECTRONICS', id: 'ELECTRONICS' },
	{
		label: 'Self Service Store',
		value: 'SELF_SERVICE_STORE',
		id: 'SELF_SERVICE_STORE',
	},
	{ label: 'Pharma', value: 'PHARMA', id: 'PHARMA' },
	{ label: 'Industrial', value: 'INDUSTRIAL', id: 'INDUSTRIAL' },
	{ label: 'Khata Mart', value: 'KHATA_MART', id: 'KHATA_MART' },
	{
		label: 'Offices Institutions',
		value: 'OFFICES_INSTITUTIONS',
		id: 'OFFICES_INSTITUTIONS',
	},
	{ label: 'Whole Seller', value: 'WHOLE_SELLER', id: 'WHOLE_SELLER' },
	{ label: 'Stationery', value: 'STATIONERY', id: 'STATIONERY' },
	{ label: 'Karachi East GT', value: 'KARACHI_EAST_GT', id: 'KARACHI_EAST_GT' },
	{ label: 'Street', value: 'STREET', id: 'STREET' },
	{ label: 'Consumer', value: 'CONSUMER', id: 'CONSUMER' },
];

export const CHANNEL_TO_STORE_TYPE_MAP: Record<string, string[]> = {
	STREET: ['FOOD_CARTS_N_DHABBA', 'PAKWAAN_CENTER'],
	GENERAL_TRADE: [
		'GENERAL_STORE',
		'BUYER',
		'MEDICAL_STORE',
		'RESTAURANTS',
		'OTHERS',
		'BAKERS',
		'COSMETICS',
		'CONFECTIONARY',
		'GENERAL_STORE_PRIME',
		'SELF_SERVICE_STORE_PRIME', // Appears in multiple channels
	],
	PHARMA: ['INDIRECT_PHARMACY', 'DIRECT_PHARMACY'],
	WHOLE_SELLER: [
		'WHOLE_SELLER',
		'WHOLE_SELLER_PRIME',
		'GENERAL_STORE', // Also appears in GENERAL_TRADE
		'SELF_SERVICE_STORE_PRIME', // Also appears in GENERAL_TRADE & SELF_SERVICE_STORE
	],
	SELF_SERVICE_STORE: ['SELF_SERVICE_STORE_PRIME', 'SELF_SERVICE_STORE'],
	OFFICES_INSTITUTIONS: [
		'OFFICES_INSTITUTIONS',
		'HOUSEHOLD', // Also appears in CONSUMER
		'CORPORATE_BUYER',
	],
	CONSUMER: [
		'HOUSEHOLD', // Also appears in OFFICES_INSTITUTIONS
		'DIGITAL_BUYER',
		'DIGITAL_OFFICES_INSTITUTIONS',
	],
	CORPORATE: ['CORPORATE', 'HORECA', 'KEY_ACCOUNTS'],
	ELECTRONICS: ['MOBILE_SHOP'],
	STATIONERY: ['STATIONERY_GIFTS'],
	INDUSTRIAL: [
		'INDUSTRIAL',
		'OTHER_TRADERS',
		'AGRICULTURE',
		'FMCG_NON_Food',
		'TRADER',
		'CONSTRUCTION',
		'FOOD_PROCESSING',
		'TEXTILE',
		'PLASTICS',
		'PHARMA', // "PHARMA" is also itself a channel
		'FLAT_STEEL',
		'STATIONERY',
		'CHEMICAL_MANUFACTURER',
		'PRINTING_INK',
		'GLASS',
		'PAINT_MANUFACTURERS',
		'PAPER_N_PACKAGING',
		'ADHESIVE_CHEMICAL',
	],
	KARACHI_EAST_GT: ['KARACHI_EAST_GT'],
};

export enum CNIC_VERIFICATION_FILTER {
	'CITIES' = 'CITIES',
	'LISTING' = 'LISTING',
	'CUSTOMER_CHANNEL' = 'CUSTOMER_CHANNEL',
}

export enum CNIC__FILTER {
	'CITIES' = 'CITIES',
	'LISTING' = 'LISTING',
}

export enum StoreStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	SUSPENDED = 'SUSPENDED',
	UNVERIFIED = 'UNVERIFIED',
	PENDING = 'PENDING',
}

export const MIN_ORDER_VALUE = 'MIN_ORDER_VALUE';

export const JWT_TOKEN = 'Invalid jwt token';
export const UNIDENTIFIED_ERROR = 'unidentified error';
export const UNAUTHORIZED_ERROR = 'Unauthorized';
export const JWT_TOKEN_EXPIRY = 'Token has expired, due to long session. Please login again.';
export const MFA_SESSION = 'Error creating Mfa Session';
export const MFA_SESSION_EXPIRY =
	'Unable to create user session. Please login with an existing user.';
export const CORRECT_PASSWORD = 'Please enter correct Password.';
export const CORRECT_OTP = 'Please enter correct OTP.';
export const OTP_MESSAGE = 'A 6-digit OTP code has been sent to you via SMS';
export const WHATSAPP_OTP_MESSAGE = 'A 6-digit OTP code has been sent to you via Whatsapp';

export const CHANNEL_CUSTOMER_APP = 'CUSTOMER_APP';
export const CHANNEL_AGENT_APP = 'AGENT_APP';
export const CHANNEL_TELESALES = 'TELESALES';
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const ASC = 'ASC';
export const TITLE = 'TITLE';
export const PAGE_SIZE = '25';
export const CATEGORY_SIZE = '150';
export const UPLOAD_CSV = 'Upload .CSV';
export const PAIYA_TOAST_MSG = 'Paiya MOV & status changes made successfully!';
export const UPLOAD_GIFT_CSV = 'Upload .CSV for gifts';
export const UPLOAD_STORE_CSV = 'Upload .CSV for stores';
export const STATUS_VALUE = 'status';

export const STORAGE_BLOCK_OPTIONS = [
	{
		value: 'GENERAL',
		label: 'GENERAL',
	},
	{
		value: 'SECURE',
		label: 'SECURE',
	},
	{
		value: 'FROZEN',
		label: 'FROZEN',
	},
];

export const organizationIds = [
	{
		id: '8444290716350960916982',
		label: 'Industrial',
	},
	{
		id: '7931660281019108183210',
		label: 'Retail',
	},
];

export const shiftMigrationTempWarhouseIds = [
	'test-warehouse-1',
	'9',
	'8',
	'11',
	'2',
	'17',
	'28',
	'5',
	'3',
	'16',
	'41',
	'49',
	'36',
	'26',
	'42',
	'12',
	'65',
	'67',
];

export const NUCLEUS_PORTAL_COLLECTION = 'Config';
export const NUCLEUS_SHOW_PHONE_LOGIN = 'showPhoneLoginToggle';
export const NUCLEUS_PORTAL_DOCUMENT_ROUTES = 'ROUTES';
export const APIKEY = process.env.REACT_APP_APIKEY;
export const AUTH_DOMAIN = 'control-tower-web-prod.firebaseapp.com';
export const PROJECT_ID = 'control-tower-web-prod';
export const STORAGE_BUCKET = 'control-tower-web-prod.firebasestorage.app';
export const MESSAGING_SENDER_ID = '895853918384';
export const APP_ID = '1:895853918384:web:7b186a6c2fac7f71976375';
export const MEASUREMENT_ID = 'G-D9EH0X4DQ1';
